<script setup lang="ts">
import {Team} from "@/types";
import {useDate} from "@/composables/date";
import VListItemValue from "@/components/navigation/VListItemValue.vue";
import {useRole} from "@/composables/role";

const {shortDate} = useDate()
const {role} = useRole()

interface Props {
    team: Team
}

const value = defineModel<boolean>()

const props = defineProps<Props>()
</script>

<template>
    <v-navigation-drawer
        v-model="value"
        location="end"
        mobile-breakpoint="sm"
        border="0"
    >
        <v-list
            nav
            class="border-b-sm mb-3"
        >
            <v-list-item-value
                label="Name"
            >
                <p class="text-body-2">
                    {{ props.team.name }}
                </p>
            </v-list-item-value>
            <v-list-item-value
                label="Short name"
            >
                <p class="text-body-2">
                    {{ props.team.short_name }}
                </p>
            </v-list-item-value>
            <v-list-item-value
                v-if="role"
                label="Role"
            >
                <p class="text-body-2 text-capitalize">
                    {{ role }}
                </p>
            </v-list-item-value>
            <v-list-item-value
                label="Created at"
            >
                <p class="text-body-2">
                    {{ shortDate(props.team.created_at) }}
                </p>
            </v-list-item-value>
            <v-list-item-value
                label="Created by"
            >
                <p class="text-body-2">
                    {{ props.team.user.name }}
                </p>
            </v-list-item-value>
        </v-list>
        <v-list
            nav
            class="border-b-sm mb-3"
        >
            <v-list-item-value
                label="Email"
            >
                <a
                    class="text-body-2 text-black"
                    :href="`mailto:${props.team.email}`"
                >
                    {{ props.team.email }}
                </a>
            </v-list-item-value>
            <v-list-item-value
                label="URL"
            >
                <a
                    v-if="props.team.url"
                    class="text-body-2 text-black"
                    :href="props.team.url"
                    target="_blank"
                >
                    {{ props.team.url }}
                    <v-icon
                        class="ml-1"
                        size="16"
                    >
                        mdi-open-in-new
                    </v-icon>
                </a>
                <p
                    v-else
                    class="text-body-2 text-disabled"
                >
                    None
                </p>
            </v-list-item-value>
        </v-list>
        <v-list
            nav
            class="border-b-sm mb-3"
        >
            <v-list-item-value
                label="Institutions and members"
            >
                <p class="text-body-2 text-wrap">
                    {{ props.team.members }}
                </p>
            </v-list-item-value>
        </v-list>
    </v-navigation-drawer>
</template>

<style scoped>

</style>
